import axios from "axios";
import { headers } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchCompanyDetails = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/bay-berry-company-details?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    console.error("Server Error", error);
    dynamicFailed(error.response.data.error.message);
  }
};
